import { render, staticRenderFns } from "./EntityFactUpdate.vue?vue&type=template&id=476216c2"
import script from "./EntityFactUpdate.vue?vue&type=script&lang=js"
export * from "./EntityFactUpdate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports